/* src/app/dashboard/leaderboard/leaderboard.component.scss */
.tab-icon {
  margin-right: 8px;
}
.mat-mdc-tab-group {
  height: 100%;
}
.mat-mdc-tab-body-wrapper {
  height: 100%;
}
.lb-loading {
  display: flex;
  flex: 1 1 auto;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  padding-top: 20px;
}
/*# sourceMappingURL=leaderboard.component.css.map */
